<template>
  <div id="root">
    <el-row type="flex" class="row-bg">
      <el-col>
        <div class="grid-content bg-purple">
          <h1>{{ title }}</h1>
        </div>
      </el-col>
    </el-row><el-row>
      <el-col>
        <h3 v-if="error">
          <!-- {{ error }} -->
          An error ocurred. Try reloading the page or confirming that you were added to Discipleship by a staff member.
        </h3>
        <div class="grid-content" style="margin-bottom: 10px;" v-if="!error">
          <el-select
            class="select-default col-md-4"
            filterable
            v-if="isOneOfTheseRoles(['regional'])"
            clearable
            style="margin:10px;"
            v-model="locationId"
            placeholder="Select location..."
          >
            <el-option
              v-for="item in locations"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </div>
      </el-col>
    </el-row>

    <div>
      <ReportingTable
        v-if="isReady"
        :reporting-data="reportingData"
      />
    </div>

    <div id="loading" v-if="(isReady == false) && (!error)">
      <h5>
        Loading...
      </h5>
    </div>
  </div>
</template>

<script>
import {
    mapState, mapGetters
} from 'vuex';
import { RepositoryFactory } from '../../repositories/repositoryFactory';
import ReportingTable from '../../components/ReportingPercentages/Table';

const DisciplesRepository = RepositoryFactory.get('disciples');

const data = 'Reporting Percentages';

export default {
    components: {
        ReportingTable,
    },
    data() {
        return {
            reportingData: null,
            error: '',
            isReady: false,
            title: 'Reporting Percentages'

        };
    },
    computed: {
        ...mapState({
            locations: (state) => state.userLocations,
        }),
        ...mapGetters({
            locationFromStore: 'lastLocation'
        }),
        locationId: {
            get() {
                return this.locationFromStore;
            },
            set(newLocation) {
                this.$store.commit('setLastLocation', newLocation);
                this.getReportingData();
            }
        }
    },
    methods: {
        getReportingData() {
            this.isReady = false;
            DisciplesRepository.getReportingTree(this.locationId)
                .then((response) => {
                    this.reportingData = response.data;
                    this.isReady = true;
                })
                .catch((error) => {
                    this.error = error.response.data.message;
                    this.isReady = true;
                });
        },
    },
    created() {
        this.getReportingData();
    },

};
</script>
